
import Share from "../../../assets/filled/Share.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShareIcon({ className, dataTestid = "ShareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Share data-testid={dataTestid} className={classes} {...rest} />
  );
}
